var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "title": _vm.text,
      "uk-tooltip": _vm.tooltipOpts
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fdbe950","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Tooltip.vue
// module id = 1896
// module chunks = 0